// extracted by mini-css-extract-plugin
export var icon = "SupportLink-module--icon--d573d";
export var link = "SupportLink-module--link--44a3c";